import { render } from "./NotFound.vue?vue&type=template&id=0a94d2a2&scoped=true"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&id=0a94d2a2&scoped=true&lang=css"

import exportComponent from "/Users/davidmarchesson2/Sites/app.idtonic.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a94d2a2"]])

export default __exports__